import React, { useContext } from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { isDesktop, isTablet } from "react-device-detect";

//ads
import Caja3 from '../../ads/Caja3';

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Button from '../common/Button';
import BackgroundImage from '../common/BackgroundImage';
import EmptySpace from '../common/EmptySpace';

const GalleryItem = props => {

    const { idPhoto } = props;    
    const { dataGallery } = useContext(GalleryContext);    
    const { gallery, qryStrStart, queryStringText, urlAssets, urlEspecial, urlPortadaEspeciales, urlVideos } = dataGallery;  
    
    const galleryItem = gallery[idPhoto];
    const { id, itemTitle, text, cuote, probability } = galleryItem;
    
    const firstItem = 1;
    const galleryKeys = Object.keys(gallery);
    const posCurrentItem = galleryKeys.indexOf(idPhoto);

    const findItemByPosition = pos => galleryKeys[pos];

    const prevItem = (id === firstItem) ? urlEspecial : `${urlEspecial}${qryStrStart}${queryStringText}=${findItemByPosition(posCurrentItem - 1)}`;

    var nextItem = `${urlEspecial}${qryStrStart}${queryStringText}=${findItemByPosition(posCurrentItem + 1)}`;
    var nextButtonText = "siguiente";

    var videoWidth = "270px";
    var videoHeight = "124px";

    if(isDesktop || isTablet){
        videoWidth = "620px";
        videoHeight = "288px";
    }

    if(id === galleryKeys.length){
        nextItem = urlPortadaEspeciales;
        nextButtonText = "+ especiales";
    }

    const backgroundImage = isDesktop ? 'background-desktop' : 'background-mobile';

    return (
        <section className="position-relative">
            <BackgroundImage alt={itemTitle} backgroundImage={backgroundImage} emptySpace={false} urlAssets={urlAssets}  />
            <section className="position-absolute start-50 translate-middle-x mx-auto px-2 px-md-0 cont-layout container-titular container-note">
                <section className="px-2 px-md-0">
                    <article className="position-relative ms-1 gallery-item">
                        <h2 className="pt-2 mb-0 rounded-circle bg-white text-center text-red id-item">{id}</h2>
                    </article>                
                    <article className="position-relative pt-4 px-md-0 gallery-item-text">
                        <h3 className="mb-0 text-red bet">Apuesta:</h3>
                        <h1 className="my-2 text-white item-title">{itemTitle}</h1> 
                        <ReactPlayer
                            className='my-4 mx-md-auto border border-white'
                            url={`${urlVideos}${id}.mp4`}
                            loop={true}
                            muted={true}
                            playing={true}
                            playsinline={true}
                            width={videoWidth}
                            height={videoHeight}
                        />
                        <p className="text-white paragraph">{text}</p>                         
                    </article>
                    <article className="py-3 border-top border-bottom border-white">
                        <h3 className="mb-1 text-red item-title">Cuota:</h3>
                        <h5 className="mt-2 text-white probability">{cuote}</h5>
                    </article>
                    <article className="py-3">
                        <h3 className="mb-1 text-red item-title">Probabilidad:</h3>
                        <h5 className="mt-1 text-white item-title">{probability}</h5>
                    </article>
                    <section className="d-flex justify-content-start mt-0 mt-md-3 mb-5 ms-2 gallery-item">
                        <section className="me-2">
                            <Button 
                                classButton="bg-white btn-start"
                                text="anterior"
                                url={prevItem}
                            />
                        </section>
                        <section className="ms-2">
                            <Button 
                                classButton="bg-red btn-next"
                                text={nextButtonText}
                                url={nextItem}
                            />
                        </section>
                    </section>
                </section>                
                <section className="content-msgs">
                    {!isDesktop && <Caja3 />}        
                </section>  
                <EmptySpace />
            </section>      
        </section>
    )
}

export default GalleryItem

GalleryItem.propTypes = {
    idPhoto: PropTypes.string.isRequired,
}